import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  buttons: {
    marginTop: (props) => props.marginTop || 44,
  },
  button: {
    width: 200,
    height: 40,
    marginRight: (props) => props.marginRightButton || '',
  },
  buttonProgress: {
    color: theme.palette.primary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  wrapper: {
    position: 'relative',
    marginBottom: (props) => (props.mobile ? 24 : ''),
  },
}));

const Buttons = ({ ...props }) => {
  const {
    onClick,
    modifiable,
    disabled,
    loading,
    onSendClick,
    onCancelClick,
    mobile,
    primaryButtonText,
    secondaryButtonText,
    marginRightButton,
    marginTop,
  } = props;
  const classes = useStyles({ mobile, marginRightButton, marginTop });
  const firstRender = useRef(true);

  const handleCancelClick = () => {
    if (onCancelClick) onCancelClick();
    if (onClick) onClick();
  };

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    if (!loading && onClick) onClick();
  }, [loading]);

  const handleSendClick = () => {
    onSendClick();
  };

  return (
    <React.Fragment>
      {modifiable && (
        <Box
          display="flex"
          flexDirection={mobile ? 'column-reverse' : 'row'}
          justifyContent={mobile ? 'space-between' : 'space-around'}
          alignContent={mobile ? 'space-between' : ''}
          alignItems={mobile ? 'center' : ''}
          className={classes.buttons}
        >
          <Button
            onClick={handleCancelClick}
            className={classes.button}
            variant="outlined"
            color="secondary"
            disabled={loading}
            data-cy="CancelButton"
          >
            {secondaryButtonText || 'Cancelar'}
          </Button>
          <div className={classes.wrapper}>
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              onClick={handleSendClick}
              disabled={loading || disabled}
              data-cy={
                primaryButtonText
                  ? `${primaryButtonText.replaceAll(/\s/g, '')}Submit`
                  : 'passwordSubmit'
              }
            >
              {primaryButtonText || 'Guardar'}
            </Button>
            {loading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </Box>
      )}
    </React.Fragment>
  );
};

Buttons.propTypes = {
  mobile: PropTypes.bool,
  onClick: PropTypes.func,
  modifiable: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onSendClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  primaryButtonText: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  marginRightButton: PropTypes.number,
  marginTop: PropTypes.number,
};

export default Buttons;
